import { ToastEventBus } from 'primevue';

export const toast = {
  add: (message: unknown) => ToastEventBus.emit('add', message),
  removeGroup: (group: string) => ToastEventBus.emit('remove-group', group),
  removeAllGroups: () => ToastEventBus.emit('remove-all-groups'),
};

export function catchError(summary: string, error: any, severity: string = 'error') {
  const { message } = error?.response?.data ?? {};

  toast.add({
    severity,
    summary,
    detail: message || error?.message || 'Неизвестная ошибка',
    life: 5000,
    closable: true,
  });

  return null;
}
